import React from 'react';
import { Button } from '../components/ui/Button';
export function CommercialCtaSection() {
  return <section className="bg-navy py-16 md:py-20" data-id="element-75">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-76">
        <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-white mb-6" data-id="element-77">
          Need Commercial Carpet or Tile Cleaning?
        </h2>
        <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-78">
          We serve businesses of all sizes across the Phoenix metro — retail,
          restaurants, offices, and more. Ask about our discounted maintenance
          packages.
        </p>
        <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-79">
          Request a Commercial Quote
        </Button>
      </div>
    </section>;
}